import React from "react";
import { Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ContactForm from "../ContactFrom/ContactForm";
import icon1 from "../../images/icons/icon_map_mark_2.svg";
import icon2 from "../../images/icons/icon_calling_2.svg";
import icon3 from "../../images/icons/icon_mail_3.svg";
import icon4 from "../../images/icons/icon_calendar_2.svg";
import hrImage from "../../images/hr-image.jpg";
//abc
const ContactSection = (props) => {
  return (
    <section className="contact_section section_space bg-light">
      <div className="container">
        <div className="contact_info_box row">
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="iconbox_block text-center">
              <div className="iconbox_icon">
                <img src={icon1} alt="Map Mark SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Global Locations</h3>
                <p className="mb-0">India, US, Europe, UAE, Singapore </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="iconbox_block text-center">
              <a
                href="https://wa.me/+919210970334?text=Hello%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services"
                target="_blank"
              >
                <div className="iconbox_icon">
                  <i
                    className="fa-brands fa-whatsapp"
                    style={{ fontSize: "26px" }}
                  ></i>
                </div>
                <div className="iconbox_content">
                  <h3 className="iconbox_title">WhatsApp</h3>
                  <p className="mb-0">Drop a message on WhatsApp</p>
                </div>
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="iconbox_block text-center">
              <div className="iconbox_icon">
                <img src={icon3} alt="User Check SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Email Us</h3>
                <p className="mb-0">info@ufsnetworks.com</p>
                {/* <p className="mb-0">hr@ufsnetworks.com</p> */}
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="iconbox_block text-center">
              <div className="iconbox_icon">
                <img src={icon4} alt="Calendar SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Office Hours</h3>
                <p className="mb-0">Monday - Sataurday</p>
                <p className="mb-0">Sunday Closed</p>
              </div>
            </div>
          </div>
        </div>
        <div className="section_space pb-0">
          <div className="row justify-content-lg-between">
            <div className="col-lg-7">
              <div className="contact_form mb-0">
                <h3 className="details_item_info_title mb-1">Contact us</h3>
                <p className="mb-5">
                  Give us chance to serve and bring magic to your brand.
                </p>
                <ContactForm />
              </div>
            </div>
            <div className="col-lg-5 ps-4">
              {/* <div className="gmap_canvas">
                <iframe
                  title="Google Maps - Unified Consultancy Services"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.276083878646!2d77.20785277925587!3d28.531420226082094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce21e1c682413%3A0x1eda673a5cea69ba!2sUnified%20Consultancy%20Services!5e0!3m2!1sen!2sin!4v1734184751000!5m2!1sen!2sin"
                  width="600"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div> */}
              <MuiLink
                component={RouterLink}
                to="/career"
                className="col-lg-12 rounded mt-4 p-4"
                style={{
                  backgroundColor: "#fff",
                  textDecoration: "none",
                  height: "auto",
                }}
              >
                <div>
                  <img
                    src={hrImage}
                    alt="UFS Network jobs"
                    style={{ height: "auto" }}
                  />
                </div>
                <h2 style={{ fontSize: "16px", lineHeight: "24px" }}>
                  Exciting Job Opportunity with Our Client!
                </h2>
                <p
                  style={{
                    marginTop: "10px",
                    fontSize: "14px",
                    marginBottom: "8px",
                  }}
                >
                  We're hiring on behalf of a reputed organization looking for
                  talented professionals to join their team.
                </p>
                <div
                  className="flex"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px 10px",
                    backgroundColor: "#e7f3ff",
                  }}
                >
                  <ul
                    style={{
                      fontSize: "14px",
                      margin: "0px",
                      paddingLeft: "16px",
                    }}
                  >
                    <li>Multiple positions open across departments</li>
                    <li>Work with an industry-leading company</li>
                    <li>Competitive salary & career growth</li>
                  </ul>
                  <a
                    href="/career"
                    className="bg-white mt-2 mb-2"
                    style={{
                      padding: "8px 16px",
                      border: "solid 1px #333",
                      borderRadius: "24px",
                      color: "#333",
                      fontSize: "12px",
                    }}
                  >
                    View jobs
                  </a>
                </div>
              </MuiLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
